<template>
	<div>
		<div class="flex justify-between">
			<div
				v-if="label"
				class="ds-text-base font-bold text-gray-800 uppercase mb-3"
			>
				{{ label }}
			</div>
		</div>

		<VideoListView v-if="isList" :videos="videos" />
		<VideoGridView v-if="isGrid" :videos="videos" />
	</div>
</template>

<script>
import VideoListView from "./ListView.vue"
import VideoGridView from "./GridView.vue"
import orderBy from "lodash/orderBy"

export default {
	components: {
		VideoListView,
		VideoGridView,
	},

	props: {
		label: { type: String, required: false },
		videos: { type: Array, required: true },
		displayMode: { type: String, default: "list" },
	},

	computed: {
		isList() {
			return this.displayMode === "list"
		},

		isGrid() {
			return this.displayMode === "grid"
		},
	},
}
</script>